<div class="mes" [ngClass]="'mes--' + layout" [class.mes--creating]="showSkeleton">
  <ind-section-header [attr.id]="sectionId" [viewData]="header" (onControlClick)="onHeaderControl($event)"></ind-section-header>

  <div class="mes-table-head" *ngIf="layout !== 'narrow' && visibleExpenses.length">
    <span>{{ 'EXPENSE' | translate }}</span>
    <span>{{ 'DATE' | translate }}</span>
    <span *ngIf="layout === 'wide'">{{ 'TYPE' | translate }}</span>
    <span *ngIf="layout === 'wide'">{{ 'MEETING_EXPENSE_SUBTYPE' | translate }}</span>
    <span class="mes-right">{{ 'AMOUNT' | translate }}</span>
    <span></span><span></span>
  </div>

  <div class="mes-row-wrap mes-skeleton" *ngIf="showSkeleton" aria-busy="true">
    <div class="mes-expanded">
      <div class="mes-expanded-head">
        <span class="mes-name mes-name--title"><ion-spinner name="crescent" class="mes-spinner"></ion-spinner>{{ 'MEETING_EXPENSE_NEW' | translate }}</span>
        <span class="mes-actions"><ion-icon name="chevron-up" class="mes-chevron"></ion-icon></span>
      </div>
      <div class="mes-skel-grid">
        <div class="mes-skel-field" *ngFor="let field of skeletonFields">
          <div class="mes-skel-label">{{ field.key | translate: { currency: currencyLabel } }}<ion-icon *ngIf="field.required" class="mandatory-icon"></ion-icon></div>
          <div class="mes-skel-value"><span class="mes-skel" [style.width.%]="field.width"></span></div>
        </div>
      </div>
    </div>
  </div>

  <div class="mes-row-wrap" *ngFor="let expense of visibleExpenses; trackBy: trackById">
    <div class="mes-row" *ngIf="expandedId !== expense.id" (click)="toggle(expense)">
      <span class="mes-name"><span class="mes-dot" [ngClass]="dotClass(expense)"></span>{{ nameOf(expense) }}</span>
      <span class="mes-date mes-muted">{{ dateText(expense) }}</span>
      <span *ngIf="layout === 'wide'">{{ expense.typeName }}</span>
      <span *ngIf="layout === 'wide'">{{ expense.subtypeName }}</span>
      <span class="mes-right mes-amount">{{ amountText(expense) }}</span>
      <span class="mes-files"><ng-container *ngIf="fileCount(expense)"><ion-icon class="mes-attach" src="assets/imgs/action_button_attachment.svg"></ion-icon>{{ fileCount(expense) }}</ng-container></span>
      <span class="mes-actions">
        <ion-icon *ngIf="layout !== 'narrow' && isEditable(expense) && scrappingId !== expense.id"
                  name="close" class="mes-scrap" (click)="scrap(expense, $event)"></ion-icon>
        <ion-icon name="chevron-down" class="mes-chevron"></ion-icon>
      </span>
    </div>

    <div class="mes-expanded" *ngIf="expandedId === expense.id">
      <div class="mes-expanded-head">
        <span class="mes-name mes-name--title"><span class="mes-dot" [ngClass]="dotClass(expense)"></span>{{ nameOf(expense) }}</span>
        <span class="mes-actions">
          <button type="button" class="mes-text-btn mes-text-btn--primary" *ngIf="isEditable(expense)"
                  [disabled]="submittingId === expense.id || scrappingId === expense.id" (click)="submit(expense)">
            <ion-icon name="checkmark"></ion-icon>{{ 'SUBMIT' | translate }}
          </button>
          <button type="button" class="mes-text-btn mes-text-btn--danger" *ngIf="isEditable(expense)"
                  [disabled]="scrappingId === expense.id" (click)="scrap(expense)">
            <ion-icon name="close"></ion-icon>{{ 'SCRAP' | translate }}
          </button>
          <ion-icon name="chevron-up" class="mes-chevron" (click)="toggle(expense)"></ion-icon>
        </span>
      </div>
      <meeting-expense-form
        *ngIf="masterData"
        [expense]="expense"
        [readOnly]="!isEditable(expense)"
        [contacts]="contacts"
        [masterData]="masterData"
        [currencyLabel]="currencyLabel"
        [notesConfig]="notesConfig"
        (expenseChange)="onExpenseChange($event)"
        (expenseSubmitted)="onExpenseSubmitted($event)">
      </meeting-expense-form>
    </div>
  </div>

  <div class="mes-empty ion-text-center ion-padding" *ngIf="!visibleExpenses.length && !isCreating">
    {{ 'MEETING_EXPENSE_NONE_YET' | translate }}
  </div>
</div>
